module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"cta":"Aceitar convite","error-cta":"Página inicial","error-title":"Convite inválido","error-subtitle":"Peça um novo link a quem lhe convidou.","title":"Você foi convidado a participar do acervo %c!","subtitle":"Entre com sua conta Fottorama ou cadastre-se.","next":"Aceitar convite"}}')
  delete Component.options._Ctor
}
